export default __webpack_public_path__ + "static/media/white-color-book.cc3e725b.png";